import { css, useTheme } from "@emotion/react";

import Box from "./Box.jsx";
import parseStyle from "./parseStyle.js";
import useThemeProps from "./useThemeProps.jsx";

const DevNotice =
  process.env.NODE_ENV !== "production"
    ? function DevNotice(props) {
        const theme = useTheme();
        props = useThemeProps({ props, name: "DevNotice" });
        let { children, style, ...restProps } = props;
        return (
          <Box
            css={css`
              ${parseStyle(style, theme)}
            `}
            {...restProps}
          >
            {children}
          </Box>
        );
      }
    : () => null;

export default DevNotice;
